import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import TechPal2 from "./TechPal2";
import Testimonials from "./Testimonials";
import reviews from "./data";


import syepMain from "../../Assets/syepMain.png";
import cf_1 from "../../Assets/syep_2025_1.jpg";
import syep2 from "../../Assets/syep_2025_2.jpg";
import syep3 from "../../Assets/techPal1.jpg";
import syep4 from "../../Assets/techPal2.jpg";
import cf_2 from "../../Assets/syep_2025.jpeg";




// Import slick-carousel styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";

const sliderImages = [
  { src: syep3, alt: "tech-pal" },
  { src: syep2, alt: "tech-pal" },
  { src: syep4, alt: "tech-pal" },
  { src: syepMain, alt: "tech-pal" },
  { src: cf_1, alt: "tech-pal" },
  { src: cf_2, alt: "tech-pal" }, 




  // Add more images as needed

  ];
console.log(sliderImages)


function TechPal() {

  const navigate = useNavigate(); // Initialize navigate
    
 
  const handleClick = () => {
    navigate("/registration#techpal-section"); // This will navigate to the "/another-page" route
  };

  
 

  // Settings for the Slick slider
  const settings = {
    dots: false, // Show dots for navigation
    infinite: true, // Infinite loop
    speed: 500, // Transition speed in ms
    slidesToShow: 1, // Show one image at a time
    slidesToScroll: 1, // Scroll one image at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Time between slides in ms
  };



  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
             {/* Second Container with the Image Slider */}
        <Container className="image-slider-container"
            style={{
              // height: "400px",
              paddingTop: "80px",
              background: "transparent", // makes the container background transparent
              position: "relative"
            }}
        
        >
        <Row>
          <Col md={12}>
            <Slider {...settings}>
              {sliderImages.map((image, index) => (
                <div key={index}>
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="img-fluid"
                    style={{ objectFit: "cover", height: "60%", width: "100%" }}
                  />
                </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
      </Container>

     

      <Button
    
  onClick={handleClick}
  variant="warning"
  size="lg"
  style={{
    color: "black",
    fontWeight: "bold",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    padding: "0.75rem 1.5rem",
    backgroundColor: "#facc15", // Tailwind yellow-400
    border: "none"
  }}
   className="custom-yellow-btn"
>
  Apply Now
</Button>

      
      
          <TechPal2 />

                                        
                    <div className="testimonials">
          <Testimonials reviews={reviews}/>              
          </div>
             

          
           
    </section>
  );
}

export default TechPal;
